var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, ModelSync, Prop } from 'vue-property-decorator';
import monacoProvider from "../../../lib/utils/monacoProvider";
/** 按照xy-client里的monacoEditor重新实现了一遍 */
let MonacoEditor = class MonacoEditor extends Vue {
  mounted() {
    var _this$value;
    // 按照xy-client里的monacoEditor重新走一遍(很怪)
    this.lastValue = String((_this$value = this.value) !== null && _this$value !== void 0 ? _this$value : '');
    monacoProvider(monaco => {
      if (!monaco) return;
      this.editor = monaco.editor.create(this.$refs.monacoContainer, {
        value: this.lastValue,
        language: 'json',
        foldingStrategy: 'indentation',
        fontSize: 16,
        fontFamily: 'Consolas, monospace',
        cursorBlinking: 'solid',
        theme: 'vs-dark',
        autoIndent: 'full',
        ...this.initOptions
      });
      this.editor.onDidChangeModelContent(() => {
        const value = this.editor.getValue();
        if (this.lastValue === value) return;
        this.lastValue = value;
        this.$emit('change', value);
      });
      this.$emit('init', this.editor);
      this.$watch(() => {
        var _this$value2;
        return String((_this$value2 = this.value) !== null && _this$value2 !== void 0 ? _this$value2 : '');
      }, value => {
        if (this.lastValue === value) return;
        this.lastValue = value;
        this.editor.setValue(value);
      });
    });
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "ref": "monacoContainer"
    });
  }
};
__decorate([Prop()], MonacoEditor.prototype, "initOptions", void 0);
__decorate([ModelSync('modelvalue', 'change', {
  type: String
})], MonacoEditor.prototype, "value", void 0);
MonacoEditor = __decorate([Component({
  name: 'MonacoEditor',
  components: {}
})], MonacoEditor);
export default MonacoEditor;
//# sourceMappingURL=MonacoEditor.js.map
